import Vue from 'vue';
import VueRouter from 'vue-router';

import Appointments from '@/pages/Appointments/Appointments';
import ClientQuestions from '@/pages/ClientQuestions/ClientQuestions';
import Deals from '@/pages/Deals/Deals';
import Guide from '@/pages/Guide/Guide';
import Login from '@/pages/Login/Login';
import News from '@/pages/News/News';
import NewsList from '@/pages/NewsList/NewsList';
import Questions from '@/pages/Questions/Questions';
import Parametric from '@/pages/Parametric/Parametric';
import ParametricPdf from '@/pages/Pdf/ParametricPdf';
import Profile from '@/pages/Profile/Profile';
import ProfileFilling from '@/pages/ProfileFilling/ProfileFilling';
import ReportProblems from '@/pages/ReportProblems/ReportProblems.vue';

Vue.use(VueRouter);

const routesArticles = [
    {
        path     : '/news',
        name     : 'NewsList',
        component: NewsList,
        meta     : {
            title          : 'Новости',
            requiresAuth   : true,
            hideSidebarNews: false
        }
    },
    {
        path     : '/news/:slug',
        name     : 'News',
        component: News,
        meta     : {
            title       : 'Новость',
            requiresAuth: true
        }
    }
];

const routes = [
    {
        path     : '/profile',
        name     : 'Profile',
        component: Profile,
        meta     : {
            title       : 'Профиль',
            requiresAuth: true
        }
    }, {
        path     : '/guide',
        name     : 'Guide',
        component: Guide,
        meta     : {
            title          : 'Гайдлайн',
            hideSidebarNews: true
        }
    }, {
        path     : '/login',
        name     : 'Login',
        component: Login,
        meta     : {
            hideSidebar    : true,
            title          : 'Личный кабинет. Вход/регистрация',
            picture        : true,
            login          : true,
            hideSidebarNews: true
        }
    }, {
        path     : '/profile-filling',
        name     : 'ProfileFilling',
        component: ProfileFilling,
        meta     : {
            hideSidebar    : true,
            title          : 'Заполнение данных',
            picture        : true,
            login          : true,
            requiresAuth   : true,
            profileFilling : true,
            hideSidebarNews: true
        }
    }, {
        path     : '/appointments',
        name     : 'Appointments',
        component: Appointments,
        meta     : {
            hideSidebar : false,
            title       : 'Записаться в офис',
            requiresAuth: true,
        }
    }, {
        path     : '/faq',
        name     : 'Questions',
        component: Questions,
        meta     : {
            hideSidebar : false,
            title       : 'Вопросы и ответы',
            requiresAuth: true
        }
    }, {
        path     : '/deals',
        name     : 'Deals',
        component: Deals,
        meta     : {
            hideSidebar    : true,
            title          : 'Сделки',
            requiresAuth   : true,
            fullWidth      : true,
            hideSidebarNews: true
        }
    }, {
        path     : '/parametric',
        name     : 'Parametric',
        component: Parametric,
        meta     : {
            hideSidebar    : true,
            title          : 'Недвижимость',
            requiresAuth   : true,
            hideSidebarNews: true
        }
    },
    {
        path     : '/client-questions',
        name     : 'ClientQuestions',
        component: ClientQuestions,
        meta     : {
            hideSidebar    : true,
            hideHeaderItems: true,
            fullWidth      : true,
            title          : 'Опросник',
            requiresAuth   : false
        }
    },
    {
        path     : '/report-problems',
        name     : 'ReportProblems',
        component: ReportProblems,
        meta     : {
            hideSidebar    : true,
            hideHeaderItems: true,
            fullWidth      : true,
            title          : 'Обращение в техническую поддержку',
            requiresAuth   : false
        }
    },
    {
        path     : '/parametric-pdf',
        name     : 'ParametricPdf',
        component: ParametricPdf,
        meta     : {
            title       : 'Печать из выборщика',
            requiresAuth: false,
            pdf         : true
        }
    }, {
        path    : '*',
        redirect: '/appointments'
    },
    ...routesArticles
];

const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes,
    scrollBehavior(to) {
        if (to.hash) {
            return {
                selector: to.hash
            };
        }
    }
});

export default router;
